import clsx from "clsx";
import React from "react";

import { Icon } from "~/assets/icons/Icon";
import Button from "~/components/ui/button/Button";

import styles from "./ResizeHandle.module.scss";

// NOTE: keeping a local copy of this type since it is not exported by @types/react-grid-layout
type RGLResizeHandle = "s" | "w" | "e" | "n" | "sw" | "nw" | "se" | "ne";

export const ResizeHandle = React.forwardRef<
  HTMLButtonElement,
  { axis: RGLResizeHandle; isVisible: boolean }
>((props, ref) => {
  const { axis, isVisible, ...restProps } = props;

  switch (axis) {
    case "s":
      return (
        <Button
          ref={ref}
          type="button"
          outlined
          className={clsx("react-resizable-handle", styles.resizeHandleSouth, {
            [styles.resizeHandleHidden]: !isVisible,
          })}
          aria-label="Resize vertically"
          {...restProps}
        >
          <Icon iconName="ResizeVerticalIcon" />
        </Button>
      );
    case "e":
      return (
        <Button
          ref={ref}
          type="button"
          outlined
          className={clsx("react-resizable-handle", styles.resizeHandleEast, {
            [styles.resizeHandleHidden]: !isVisible,
          })}
          aria-label="Resize horizontally"
          {...restProps}
        >
          <Icon iconName="ResizeHorizontalIcon" />
        </Button>
      );
    case "w":
      return (
        <Button
          ref={ref}
          type="button"
          outlined
          className={clsx("react-resizable-handle", styles.resizeHandleWest, {
            [styles.resizeHandleHidden]: !isVisible,
          })}
          aria-label="Resize horizontally"
          {...restProps}
        >
          <Icon iconName="ResizeHorizontalIcon" />
        </Button>
      );
    default:
      return null;
  }
});
